import GUI from 'lil-gui';

export interface DebugTuning {
  exposure: number;
  maxDpr: number;
  aiSkill: number;
}

export class DebugTools {
  private gui: GUI | null = null;

  constructor(tuning: DebugTuning, onChange: (key: keyof DebugTuning) => void) {
    const enabled = new URLSearchParams(window.location.search).has('debug');
    if (!enabled) return;

    this.gui = new GUI({ title: 'Fútbol Fighters tuning' });
    this.gui.add(tuning, 'exposure', 0.6, 1.8, 0.01).onChange(() => onChange('exposure'));
    this.gui.add(tuning, 'maxDpr', 1, 2, 0.25).onChange(() => onChange('maxDpr'));
    this.gui.add(tuning, 'aiSkill', 0.2, 1, 0.02).onChange(() => onChange('aiSkill'));
  }

  setHidden(hidden: boolean): void {
    if (!this.gui) return;
    if (hidden) this.gui.hide();
    else this.gui.show();
  }

  dispose(): void {
    this.gui?.destroy();
    this.gui = null;
  }
}
